import React, { useEffect, useState } from 'react';
import { useWindowDimensions, View } from 'react-native';
import { Image } from './Image';
import { Image as SkeletonImage } from '../skeleton';
export const HeroImage = ({ uri, style = { alignSelf: 'center' }, isLoading = false, }) => {
    const [isRendered, setIsRendered] = useState(false);
    const { height, width } = useWindowDimensions();
    const [aspectRatio, setAspectRatio] = useState();
    const maxHeight = typeof window === 'undefined'
        ? undefined
        : Math.min(height * 0.75, width) / (aspectRatio || 1);
    useEffect(() => setIsRendered(true), []);
    if (isLoading || !isRendered) {
        return (React.createElement(SkeletonImage, { width: '100%', height: (width || 200) / 3 }));
    }
    ;
    return (React.createElement(View, { style: {
            alignItems: 'center',
            overflow: 'hidden',
            maxHeight,
        } },
        React.createElement(View, { style: { width: '100%' } },
            React.createElement(Image, { uri: uri, style: {
                    height: maxHeight,
                    maxHeight,
                    width: '100%',
                    filter: 'blur(40px)',
                    WebkitFilter: 'blur(40px)',
                }, resizeMode: "cover" })),
        React.createElement(View, { style: { position: 'absolute' } },
            React.createElement(Image, { uri: uri, heightConstraint: maxHeight, onSize: (dims) => {
                    if (!aspectRatio) {
                        setAspectRatio(dims.width / dims.height);
                    }
                }, style: { ...style, maxHeight }, isLoading: isLoading }))));
};
//# sourceMappingURL=HeroImage.web.js.map